export default __webpack_public_path__ + "static/media/3.a91e1c7f.svg";